import { useState } from 'react';
import { HallPage } from './pages/Hall';
import { GamePage } from './pages/Game';
import { LoginPage } from './pages/Login';
import { useGameStore } from './store/gameStore';

function App() {
  const { currentPage, isLoggedIn } = useGameStore();
  
  // 根据状态渲染不同页面
  if (!isLoggedIn) {
    return <LoginPage />;
  }
  
  if (currentPage === 'hall') {
    return <HallPage />;
  }
  
  if (currentPage === 'game') {
    return <GamePage />;
  }
  
  return <HallPage />;
}

export default App;